import type { GameHeaderPort } from "./GameHeaderPort";

export class GameHeaderPresenter {
  private timerId: ReturnType<typeof setInterval> | undefined;

  constructor(
    private readonly panel: GameHeaderPort,
    private readonly title: string,
  ) {}

  public start(): void {
    this.panel.setTitle(this.title);
    this.renderTime();

    this.timerId = setInterval(() => {
      this.renderTime();
    }, 1000);
  }

  public stop(): void {
    if (this.timerId !== undefined) {
      clearInterval(this.timerId);
      this.timerId = undefined;
    }
  }

  private renderTime(): void {
    this.panel.setTime(this.formatNow(new Date()));
  }

  private formatNow(date: Date): string {
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  }
}